import React, { useState, useEffect } from 'react';
import './style/UserManagementPage.css';
import NavBarAdmin from './NavBarAdmin';
import UserMngById from "./UserMngById";
import config from './config/config';
import { useNavigate } from 'react-router-dom';

const SESSION_TIMEOUT = 10 * 60 * 1000; // 10 минут

const apiGetAll = `${config.apiUrl1}/api/users/getall`;
const apiCreate = `${config.apiUrl1}/api/users/create`;
const apiUpdate = `${config.apiUrl1}/api/users/update`;
const apiDelete = `${config.apiUrl1}/api/users/delete`;
const apiGetCarsByUser = (userId) => `${config.apiUrl2}/api/cars/get-by-user-id/${userId}`;

function UserManagementPage() {
    const initialForm = {
        full_name: '',
        phone_number: '',
        passport_number: '',
    };

    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState(initialForm);
    const [editId, setEditId] = useState(null);
    const [showUserMngByIdModal, setShowUserMngByIdModal] = useState(false);
    const [selectedUserPhone, setSelectedUserPhone] = useState(null);
    const [checkCard, setCheckCard] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);
            if (diff > SESSION_TIMEOUT) {
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
                navigate('/panel/admin-panel');
            }
        } else {
            navigate('/panel/admin-panel');
        }
    }, []);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const res = await fetch(apiGetAll);
            const data = await res.json();
            setUsers(data);
        } catch (err) {
            console.error('Ошибка получения пользователей:', err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEdit = (user) => {
        setEditId(user.id);
        setFormData({
            full_name: user.full_name || '',
            phone_number: user.phone_number || '',
            passport_number: user.passport_number || '',
        });
    };

    const handleCancel = () => {
        setEditId(null);
        setFormData(initialForm);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editId ? 'PUT' : 'POST';
        const url = editId ? `${apiUpdate}/${editId}` : apiCreate;

        try {
            await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            fetchUsers();
            setFormData(initialForm);
            setEditId(null);
        } catch (err) {
            console.error('Ошибка сохранения пользователя:', err);
        }
    };

    // ✅ Удаление пользователя
    const handleDelete = async (id) => {
        if (!window.confirm('Вы уверены, что хотите удалить этого пользователя?')) return;

        try {
            const res = await fetch(`${apiDelete}/${id}`, { method: 'DELETE' });
            if (res.ok) {
                alert('Пользователь успешно удалён.');
                fetchUsers();
            } else {
                alert('Ошибка при удалении пользователя.');
            }
        } catch (err) {
            console.error('Ошибка удаления пользователя:', err);
        }
    };

    const handleOpenUserMngById = (user) => {
        setSelectedUserPhone(user.phone_number);
        setCheckCard(user.card_id !== 0);
        setShowUserMngByIdModal(true);
    };

    const handleCloseUserMngById = () => {
        setShowUserMngByIdModal(false);
        setSelectedUserPhone(null);
    };

    return (
        <div className="user-mng-page">
            <header className="header">
                <NavBarAdmin />
            </header>

            <div className="profile-container">
                <h2>{editId ? 'Редактировать пользователя' : 'Создать пользователя'}</h2>
                <form onSubmit={handleSubmit} className="form-container">
                    <input name="full_name" value={formData.full_name} onChange={handleChange} placeholder="ФИО" required />
                    <input name="phone_number" value={formData.phone_number} onChange={handleChange} placeholder="Телефон" required />
                    <input name="passport_number" value={formData.passport_number} onChange={handleChange} placeholder="Паспорт" required />
                    <div className="button-group">
                        <button type="submit" className="order-btn">{editId ? 'Обновить' : 'Создать'}</button>
                        {editId && (
                            <button type="button" className="logout-btn" onClick={handleCancel}>
                                Отмена
                            </button>
                        )}
                    </div>
                </form>

                <table className="history-table">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>ФИО</th>
                        <th>Телефон</th>
                        <th>Паспорт</th>
                        <th>Карта ID</th>
                        <th>Карта Номер</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map(user => (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.full_name}</td>
                            <td>{user.phone_number}</td>
                            <td>{user.passport_number}</td>
                            <td>{user.card_id}</td>
                            <td>{user.card_number}</td>
                            <td>
                                <button onClick={() => handleEdit(user)} title="Редактировать">✏️</button>
                                <button onClick={() => handleOpenUserMngById(user)} title="Управление услугами">🛠️</button>
                                <button onClick={() => handleDelete(user.id)} title="Удалить">🗑️</button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {showUserMngByIdModal && (
                <div className="modal-overlay">
                    <div className="modal-content modal-large">
                        <button
                            className="logout-btn"
                            onClick={handleCloseUserMngById}
                            style={{ float: 'right' }}
                        >
                            ✖️ Закрыть
                        </button>
                        <UserMngById
                            phone={selectedUserPhone}
                            onClose={handleCloseUserMngById}
                            checkCard={checkCard}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default UserManagementPage;
